import React from "react";

const CampaignStatusBadge = ({ status }) => (
    <span className={`crm-campaign-status-badge crm-campaign-status-badge--${status}`}>
        {status}
    </span>
);

export default CampaignStatusBadge;
